import React, { useState } from "react";
import styled from "styled-components";
import { driverDB } from "../../services";
import { useVeryNotificationsContext } from "../../components/common/v2/VeryNotifications/useVeryNotifications";
import { VeryInput } from "../../components/common/v2/VeryInput";
import { VeryBtnFill } from "../../components/common/v2/VeryBtnFill";
import { classVeryBtnFill } from "../../components/common/v2/VeryBtnFill/classVeryBtnFill";
import logoVery from "../../assets/logos/very-yellow-icon-01.png";

const DivContainer = styled.main`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #13131D;
  font-family: "Roboto", Helvetica, sans-serif;
  padding: 20px;
  box-sizing: border-box;
`;

const Card = styled.div`
  width: 100%;
  max-width: 420px;
  background-color: #FFFFFF;
  border-radius: 20px;
  padding: 40px 30px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

const Logo = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #13131D;
  margin: 0 0 10px 0;
  text-align: center;
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: #6C757D;
  margin: 0 0 30px 0;
  text-align: center;
  line-height: 1.5;
`;

const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default function RecoveryDriver() {
  const [tel, setTel] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const notis = useVeryNotificationsContext();

  const handleTextChange = (text) => {
    // Only allow digits
    const cleanText = text.replace(/\D/g, "");
    if (cleanText.length <= 10) {
      setTel(cleanText);
      setError("");
    }
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (tel.length === 0) {
      setError("Por favor ingresa tu número telefónico");
      return;
    }
    if (tel.length !== 10) {
      setError("El número telefónico debe tener exactamente 10 dígitos");
      return;
    }

    setLoading(true);
    try {
      const resp = await driverDB.resendTempPassword(tel);
      setLoading(false);
      if (resp.error) {
        notis.createNotiError("Error al reenviar contraseña", resp.error.details || resp.error.message);
      } else {
        notis.createNotiSuccess("SMS Reenviado con éxito", "Recibirás un mensaje de texto con tu contraseña temporal en unos momentos.");
        setTel("");
      }
    } catch (err) {
      setLoading(false);
      notis.createNotiError("Error en el servidor", "Algo salió mal al procesar tu solicitud.");
    }
  };

  return (
    <DivContainer>
      <Card>
        <Logo src={logoVery} alt="Very Logo" />
        <Title>Reenviar Contraseña Temporal</Title>
        <Subtitle>
          Si te registraste como conductor en Very y no recibiste el SMS con tu contraseña temporal, ingresa tu teléfono de 10 dígitos para solicitar el reenvío.
        </Subtitle>
        <Form onSubmit={handleSubmit}>
          <VeryInput
            isEditable={!loading}
            text={tel}
            onChangeText={handleTextChange}
            title="Número telefónico"
            textError={error}
            placeHolder="Ej. 3111234567"
            onLostFocus={() => {}}
            onEnter={handleSubmit}
          />
          <VeryBtnFill
            colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
            label="Reenviar SMS"
            textSize={14}
            isLoading={loading}
            onClick={handleSubmit}
          />
        </Form>
      </Card>
    </DivContainer>
  );
}
